<template>
  <div class="home-dashboard-update">
    <div class="home-dashboard-update-header">
      <TText
        value="Last_Login:_{timestamp}"
        :value_props="{timestamp: last_login.substring(0, 16)}"
        font_weight="500"
        size="14"
      />
      <!-- <p style="margin-bottom: 0px"> {{$t("Home.UserHome.Updated.LastLogin")}}: {{last_login.substring(0, 16)}}</p> -->
    </div>
    <div class="home-dashboard-update-content">
        <TText
          value="You_have_{count}_INVITATIONS"
          :value_props="{count: invite_count}"
          font_weight="300"
          medium
        />
        <TText
          value="You_have_{count}_IMAGES_in_your_projects"
          :value_props="{count: image_count}"
          font_weight="300"
          medium
        />
        <TText
          value="You_have_{count}_LOGLIST_entries_in_your_projects"
          :value_props="{count: loglist_count}"
          font_weight="300"
          medium
        />
    </div>
    <div class="home-dashboard-update-footer">
      <TText
        value="within_the_last_week"
        font_weight="300"
        medium
      />
    </div>
  </div>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue'

export default {
  props: ['last_login', 'image_count', 'invite_count', 'loglist_count'],
  components: {
    TText
  },
}
</script>

<style>
.home-dashboard-update-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  text-align: center;
}
.home-dashboard-update {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: baseline; */
}
.home-dashboard-update-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 10px);
  /* align-items: center; */
  padding: 10px 3px 3px 3px;
}
.home-dashboard-update-footer {
  text-align: right;
  padding: 5px;
  width: calc(100% - 5px);
}
.line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
